import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import "./styles/styles.scss";

let language = window.location.pathname.replace(/^\/([^/]*).*$/, '$1');
if (language === "en") {
  window.languageInt = 1;
  window.language = "en";
  window.projectLink = "project";
  window.newsLink = "news";

  window.keywords = {
    fullName: 'Full name',
    message: 'Message',
    sendMessage: 'Send message',
    sendBtnMessage: 'Send',
    sendBtnSending: 'Sending...',
    requiredField: 'This field is required',
    correctEmail: 'Enter a valid email',
    formSend: 'Your message has been sent.',
    enterCorrectEmail: 'Please use correct email format.'
  }
} else {
  window.languageInt = 0;
  window.language = "me";
  window.projectLink = "projekat";
  window.newsLink = "novosti";

  window.keywords = {
    fullName: 'Ime i prezime',
    message: 'Poruka',
    enterCorrectEmail: 'Unesite ispravnu email adresu.',
    sendMessage: 'Pošaljite poruku',
    sendBtnMessage: 'Pošalji',
    sendBtnSending: 'Šalje se...',
    requiredField: 'Ovo polje je obavezno',
    correctEmail: 'Unesite ispravnu email adresu',
    formSend: 'Vaša forma je poslata.',
  }
}

const rootElement = document.getElementById("root");
ReactDOM.render(
  <Router>
    <App />
  </Router>,
  rootElement
);